import React from "react";
import cn from "classnames";
import styles from "./styles.module.scss";

const TitleProduct = ({
  title,
  titleStyles = {},
  subtitle,
  text,
  textStyles = {},
  actions,
  actionStyles = {},
  icon,
  limitWidth = false,
  containerStyles,
  titlePaddings,
}) => {
  return (
    <div className={cn(styles.title, { icon })} style={titlePaddings}>
      <div className={cn("container", containerStyles)}>
        {icon && (
          <div className={styles.icon}>
            <img src={icon} alt={title} width={92} height={92} />
          </div>
        )}
        {subtitle && <p className={styles.subtitle}>{subtitle}</p>}

        <h1 style={titleStyles}>{title}</h1>
        {text && (
          <p
            style={{
              ...textStyles,
              margin: "0 auto",
              maxWidth: limitWidth ? "600px" : "inherit",
            }}
            className="text_xl"
          >
            {text}
          </p>
        )}

        {actions && (
          <div style={actionStyles} className={styles.actions}>
            {actions}
          </div>
        )}
      </div>
    </div>
  );
};

export default TitleProduct;
